import 'slick-carousel/slick/slick.css';

import './index.css';

import cn from 'client/utils/cn';
import React, { Component, CSSProperties, TouchEvent } from 'react';
import Slider from 'react-slick';

import { PropsMainSlider } from 'client/bundles/types';

const SETTINGS = {
    autoplaySpeed: 6 * 1000,
    autoplay: true,
    dots: true,
    infinite: true,
    easing: 'ease-in-out',
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
};

const b = cn('slider2');

interface Props {
    slider: PropsMainSlider[];
}

class Slider2 extends Component<Props> {
    private firstClientX: number;
    private clientX: number;
    private sliderNode: HTMLElement | null;

    constructor(props: Props) {
        super(props);

        this.touchStart = this.touchStart.bind(this);
        this.preventTouch = this.preventTouch.bind(this);
    }

    componentDidMount() {
        this.sliderNode = document.getElementById('slider2');

        if (!this.sliderNode) {
            return;
        }

        // @ts-ignore
        this.sliderNode.addEventListener('touchstart', this.touchStart);
        // @ts-ignore
        this.sliderNode.addEventListener('touchmove', this.preventTouch, { passive: false });
    }

    componentWillUnmount() {
        if (!this.sliderNode) {
            return;
        }

        // @ts-ignore
        this.sliderNode.removeEventListener('touchstart', this.touchStart);
        // @ts-ignore
        this.sliderNode.removeEventListener('touchmove', this.preventTouch, { passive: false });
    }

    render() {
        const { slider } = this.props;

        return (
            <div id="slider2">
                <Slider
                    {...SETTINGS}
                    className={b()}
                    dotsClass={b('bullets')}
                    >
                    {slider.map(item => (
                        <div key={item['480'].image} className={b('image-item')}>
                            <div
                                className={b('image')}
                                style={this.getStyle(item)}
                                />
                        </div>
                    ))}
                </Slider>
            </div>
        );
    }

    private getStyle(item: PropsMainSlider): CSSProperties {
        return {
            '--image-480': `url(${item['480'].image})`,
            '--image-2560': `url(${item['2560'].image})`,
            '--background-position-480': `${item['480'].position}`,
            '--background-position-2560': `${item['2560'].position}`
        } as CSSProperties;
    }

    private touchStart(e: TouchEvent): void {
        this.firstClientX = e.touches[0].clientX;
    }

    // Вертикальный скрол запрещен во время горизонтального swipe
    // https://github.com/akiran/react-slick/issues/1240
    private preventTouch(e: TouchEvent): void {
        const minValue = 5; // threshold

        this.clientX = e.touches[0].clientX - this.firstClientX;

        if (Math.abs(this.clientX) > minValue) {
            e.preventDefault();
        }
    }
}

export default Slider2;
